/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OriginsInputs */

const en_origins = /** @type {(inputs: OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origins`)
};

const es_origins = /** @type {(inputs: OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origenes`)
};

/**
* | output |
* | --- |
* | "Origins" |
*
* @param {OriginsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origins = /** @type {((inputs?: OriginsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OriginsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origins(inputs)
	return es_origins(inputs)
});